const TEMPLATE = `
<section class="vacancies-list-section fade-up">
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-6 col-md-6">
                <p class="section-label" data-animate-child>Актуальні вакансії</p>
            </div>
            <div class="col-lg-6 col-md-6">
                <h2 data-animate-child data-delay="200">
                    Відкриті позиції у BML
                </h2>
                <p data-animate-child data-delay="600">
                    Приєднуйтесь до нашої лабораторії та станьте частиною команди, яка впроваджує медицину
                    майбутнього вже сьогодні.
                </p>
            </div>
        </div>


        <div data-section="vacancies-section" id="vacancies-section">
            <!-- Сюди завантажуватимуться блоки вакансій -->
        </div>
        <a class="load-more-" href="#">Завантажити більше</a>


    </div>
</section>
`;

class BmlVacanciesList extends HTMLElement {
    connectedCallback() { if (!this.innerHTML.trim()) this.innerHTML = TEMPLATE; }
}
customElements.define('bml-vacancies-list', BmlVacanciesList);
